import router from "@/router";
import { alteraMensagemErroAxios, alteraIconErroAxios, alteraHeaderAxios, errosAxios, store } from "@/store/store.js";
import { descriptografarObjetoSession } from "@/utils/encryptedStorage.js";
import axios from "axios";

const axiosInstance = axios.create({
  timeout: 1000 * 20,
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // Ignora erros de requisições canceladas (AbortError)
    if (error.name === "AbortError" || error.name === "CanceledError") {
      return Promise.reject(error);
    }

    if (error.message.includes("timeout")) {
      // Timeout ocorreu
      alteraMensagemErroAxios(
        "Timeout na requisição. Verifique sua conexão ou tente novamente mais tarde."
      );
      logError(error);
      errosAxios.erroAxios = true;
      return Promise.reject(error);
    } else if (error.message.includes("Network Error")) {
      // Erro de rede ocorreu
      alteraMensagemErroAxios("Erro de rede. Verifique sua conexão ou tente novamente mais tarde.");
      logError(error);
      errosAxios.erroAxios = true;
      return Promise.reject(error);
    } else if (error.response) {
      // Ignorar erro 404
      if (error.response.status === 404) {
        return Promise.reject(error);
      }

      // A requisição foi feita e o servidor respondeu com um código de erro
      switch (error.response.status) {
        case 400:
          alteraMensagemErroAxios(error.response.data?.error || "Erro desconhecido");
          logError(error);
          break;
        case 403:
          alteraMensagemErroAxios("Acesso negado. Realize o login novamente.");
          logError(error);
          errosAxios.erroAxios = true;
          sessionStorage.clear();
          router.push("/login");
          break;
        case 405:
          alteraMensagemErroAxios(
            "Licença de testes expirada! Entre em contato com o comercial para contratar a aplicação ou estender o período de testes."
          );
          logError(error);
          errosAxios.erroAxios = true;
          router.push("/login");
          break;
        case 409:
          alteraMensagemErroAxios(error.response.data?.error || "Erro desconhecido");
          errosAxios.erroAxios = true;
          break;
        case 500:
          alteraMensagemErroAxios(`Erro interno do servidor. Erro: ${error.message}`);
          logError(error);
          errosAxios.erroAxios = true;
          break;
        case 503:
          alteraMensagemErroAxios(error.response.data?.error || "Serviço indisponível no momento. Tente novamente mais tarde.");
          alteraIconErroAxios("pi pi-hammer aviso");
          alteraHeaderAxios("Fluxus em manutenção!");
          logError(error);
          errosAxios.erroAxios = true;
          router.push("/");
          break;
        default:
          alteraMensagemErroAxios(`Erro não catalogado. Erro: ${error.message}`);
          logError(error);
          errosAxios.erroAxios = true;
      }
      return Promise.reject(error);
    } else if (error.request) {
      // A requisição foi feita, mas não houve resposta do servidor
      alteraMensagemErroAxios(
        "Sem resposta do servidor. Verifique sua conexão ou tente novamente mais tarde."
      );
      errosAxios.erroAxios = true;
      return Promise.reject(error);
    } else {
      // Outro tipo de erro ocorreu
      alteraMensagemErroAxios(`Erro não catalogado. Erro: ${error.message}`);
      errosAxios.erroAxios = true;
    }
    return Promise.reject(error);
  }
);

async function logError(error) {
  const idCliVN = await descriptografarObjetoSession("logData", "fluxus_mobile_idCliVN");
  const mnemonico = await descriptografarObjetoSession("logData", "fluxus_mobile_mnemonico");

  const errorDetails = {
    logId: 0,
    clientId: idCliVN,
    mnemonico: mnemonico,
    versionFM: store.versaoFluxusMobile,
    logDate: new Date().toISOString(),
    error: error.response?.data?.error || error.message || "Erro não catalogado",
    userAgent: navigator.userAgent,
    platForm: navigator.platform,
    screenWidth: window.screen.width,
    screenHeight: window.screen.height,
    connectionType: navigator.connection
      ? navigator.connection.effectiveType || "Não disponível"
      : "Não disponível",
    url: window.location.href,
  };

  try {
    await axiosNoInterceptors.post(`${store.urlBackoffice}/logErrorFM`, errorDetails, {
      headers: {
        Authorization: `Bearer ${store.tokenBackoffice}`,
      },
    });
  } catch {
    // O registro de telemetria não pode interromper o fluxo principal da aplicação.
  }
}

export default axiosInstance;

const axiosNoInterceptors = axios.create();
export { axiosNoInterceptors };
